import { Injectable } from '@angular/core';
import { LoadingController, App, AlertController, ToastController, Events, Platform} from 'ionic-angular';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Storage } from '@ionic/storage';
import { FormatindianstylePipe } from '../../pipes/formatindianstyle/formatindianstyle';

import 'rxjs/add/operator/map';

/*
  Generated class for the ConstantsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/

@Injectable()

export class ConstantsProvider 
{
public SERVER_NAME ='https://api.kmposoffline.com';

	public loader;
	public version = '1.0.0';
	public targettype: string = '';
	public targetname: string = '';
	public toastrefference:any;
	public my_store_id : any = '';
	public my_access_key : any = '';
	public response_data : any = '';
	public hasCfsScreen:any='unknown';
	public cfs_node_api_address = 'https://localhost.plutokm.com:8085';

	constructor
	(
		public http: Http,
		public app: App,
		public storage: Storage,
		public loadingCtrl: LoadingController,
		public alertCtrl : AlertController,
		private toast: ToastController,
		public events: Events,
		public platform: Platform,
		private formatIndianStyle: FormatindianstylePipe,
	)
	{
		this.setTargetTypeAndName();
	}

	//options : {content : 'Please wait', dismissOnPageChange: true/false, duration : inmilliseconds} 
	createLoader(options)
	{
		return this.loadingCtrl.create(options);
	}

	presentAlert(title, body) 
	{
	  let alert = this.alertCtrl.create({
	    title: title,
	    subTitle: body,
	    buttons: ['Ok']
	  });
	  alert.present();
	}


	showConfirm(title:string, msg:string, s:any, f:any) 
	{
	    let confirm = this.alertCtrl.create({
	      title: title,
	      message: msg,
	      buttons: [
	        {
	          text: 'Disagree',
	          handler: () => {
	            f()
	          }
	        },
	        {
	          text: 'Agree',
	          handler: () => {
	            s()
	          }
	        }
	      ]
	    });
	    confirm.present();
  	}


	presentToast(toastconfig) 
	{
		try {
			this.toastrefference.dismiss();
    	} catch(e) {}
		this.toastrefference = this.toast.create(toastconfig);
		this.toastrefference.present();
	}


	getPlatforms() 
	{
		return this.platform.platforms();
	}


	getPlatformObj() 
	{
		return this.platform;
	}


	setTargetTypeAndName() 
	{
		let type = 'app', name;
		if(!window.location.hostname){
            name = this.platform.is('android') ? 'android' : this.platform.is('ios') ? 'ios' : 'windows';
        }else{
            type = 'browser';
            name = navigator.userAgent;
        }
        this.targettype = type;
        this.targetname = name;
	}


	getCustomAppHeaders(storeid, userkey) 
	{
		let opt: RequestOptions
		let headers: Headers = new Headers
		headers.set('Content-type', 'application/json')
		headers.set('Pos-User-Access-Store-Id', storeid);
		headers.set('Pos-Access-Token', userkey);
		opt = new RequestOptions({
		  headers: headers
		});
		return opt;
	}





	sendGetRequestWithoutAccessKey(end_point) 
	{
		return new Promise(resolve =>
		{
			this.storage.get('store_id').then((data) => 
			{
		    	this.my_store_id = data;
		    });
		    this.storage.get('user_access_key').then((data) => 
			{
				this.my_access_key = data;
				let headers: Headers = new Headers;
				headers.append('Content-type', 'application/json');
				this.http.get(this.SERVER_NAME + end_point, {headers : headers} )
				.map(response => response.json())
			    .subscribe(data => 
			    {
			    	if(data.success == 0) {
			        	resolve(data);
			        }
			        if(data.success == 1) {
			        	resolve(data);
			        }
			    });
			});
		});
	}







	sendGetRequest(end_point) 
	{
		return new Promise(resolve =>
		{
			this.storage.get('store_id').then((data) => 
			{
		    	this.my_store_id = data;
		    });
		    this.storage.get('user_access_key').then((data) => 
			{
				this.my_access_key = data;
				let headers: Headers = new Headers;
				headers.append('Content-type', 'application/json');
				headers.append('Pos-Access-Token', this.my_access_key);
				headers.append('Pos-User-Access-Store-Id', this.my_store_id);

				this.http.get(this.SERVER_NAME + end_point, {headers : headers} )
				.map(response => response.json())
			    .subscribe(data => 
			    {
			    	let nav = this.app.getActiveNav();
			    	if(data.success == 0) {
			        	resolve(data);
			        }
			        if(data.success == 1) {
			        	resolve(data);
			        }
			        if(data.success == 2) {
			        	// alert( data.msg );
			        	// nav.setRoot('HomePage');
			        }
			        if(data.success == 3) 
			        {	
			        	this.storage.remove('store_id').then(() => { });
			            this.storage.remove('user_access_key').then(() => { });
			            this.storage.remove('store_name').then(() => { });
			            this.storage.remove('user_name').then(() => { });
			            this.storage.remove('user_id').then(() => { });
			            this.storage.remove('app_runnig_mode').then(() => { });
			            this.storage.remove('app_runnig_mode_string').then(() => { });
			            this.storage.remove('app_runnig_mode_string').then(() => { });
			            this.storage.remove('ds_prefix').then(() => {
			                nav.setRoot('LoginPage');
			            });
			        }
			    });
			});
		});
	}





	sendPostRequest(end_point, post_data)
	{
		return new Promise(resolve =>
		{
			this.storage.get('store_id').then((data) => 
			{
		    	this.my_store_id = data;
		    });
		    this.storage.get('user_access_key').then((data) => 
			{
				this.my_access_key = data;
				let headers: Headers = new Headers;
				headers.append('Content-type', 'application/json');
				headers.append('Pos-Access-Token', this.my_access_key);
				headers.append('Pos-User-Access-Store-Id', this.my_store_id);
				
				let json_capsule = JSON.stringify(post_data);

				this.http.post( this.SERVER_NAME + end_point, json_capsule, {headers : headers} )
				.map(response => response.json())
			    .subscribe(data => 
			    {
			    	let nav = this.app.getActiveNav();
			    	if(data.success == 0) {
			        	resolve(data);
			        }
			        if(data.success == 1) {
			        	resolve(data);
			        }
			        if(data.success == 2) {
			        	// alert( data.msg );
			        	// nav.setRoot('HomePage');
			        }
			        if(data.success == 3) 
			        {
			        	this.storage.remove('store_id').then(() => { });
			            this.storage.remove('user_access_key').then(() => { });
			            this.storage.remove('store_name').then(() => { });
			            this.storage.remove('user_name').then(() => { });
			            this.storage.remove('user_id').then(() => { });
			            this.storage.remove('app_runnig_mode').then(() => { });
			            this.storage.remove('app_runnig_mode_string').then(() => { });
			            this.storage.remove('app_runnig_mode_string').then(() => { });
			            this.storage.remove('ds_prefix').then(() => {
			                nav.setRoot('LoginPage');
			            });
			        }
			    });
			});
		});
	}





	sendPostRequestWithoutAccessKey(end_point, post_data)
	{
		return new Promise(resolve =>
		{
			this.storage.get('store_id').then((data) => 
			{
		    	this.my_store_id = data;
		    });
		    this.storage.get('user_access_key').then((data) => 
			{
				this.my_access_key = data;
				let headers: Headers = new Headers;
				headers.append('Content-type', 'application/json');
				
				let json_capsule = JSON.stringify(post_data);
				this.http.post( this.SERVER_NAME + end_point, json_capsule, {headers : headers} )
				.map(response => response.json())
			    .subscribe(data => 
			    {
			    	if(data.success == 0) {
			        	resolve(data);
			        }
			        if(data.success == 1) {
			        	resolve(data);
			        }
			    });
			});
		});
	}







	printThermalReceipt( print_data : any, print_method_in_node : string, timeout : number  = 0  )
	{
		this.storage.get('printer_address').then((data) => 
		{
			setTimeout(function()
			{
				let printer_address = data;
				if(!window.location.hostname)
				{
					let headers = new Headers;
					headers.append('Content-type', 'application/json');
					headers.append('Access-Control-Allow-Origin', '*');
					let options = new RequestOptions({
						headers: headers
					});

					return this.http.post(printer_address +"/"+ print_method_in_node, print_data , options )
					.map(response => response.json())
					.subscribe(data => {
						//console.log(data);
				    });
				}
				else
				{
					var http = new XMLHttpRequest();
					var url = printer_address +"/"+ print_method_in_node;
					http.open("POST", url, true);
					http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
					http.timeout = 3000; // time in milliseconds

					http.onreadystatechange = function() 
					{ //Call a function when the state changes.
					    if(http.readyState == 4 && http.status == 200) {
					        //console.log(http.responseText);
					    }
					}

					http.ontimeout = function (e) {
						alert("Print Service is not available, Contact IT Team. Issue may be one of the below reasons a.)Check Print Service is running or not  b.)Check google chrome extension `insecure private network requests` is DISABLED or not");
					}

					http.send(print_data);
			    }
		    }, timeout);
		});
	}





	printTFSLabel( print_data : any, print_method_in_node : string, printer_address : string  )
	{
		if(!window.location.hostname)
		{
			let headers = new Headers;
			headers.append('Content-type', 'application/json');
			headers.append('Access-Control-Allow-Origin', '*');
			let options = new RequestOptions({
				headers: headers
			});

			return this.http.post(printer_address +"/"+ print_method_in_node, print_data , options )
			.map(response => response.json())
			.subscribe(data => {
				//console.log(data);
		    });
		}
		else
		{
			var http = new XMLHttpRequest();
			var url = printer_address +"/"+ print_method_in_node;
			http.open("POST", url, true);
			http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

			http.onreadystatechange = function() 
			{ //Call a function when the state changes.
			    if(http.readyState == 4 && http.status == 200) {
			        //console.log(http.responseText);
			    }
			}
			http.send(print_data);
	    }
	}



	//Refrence # https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator
	//Example #2: Browser detect and return an index
	getBrowserType() 
	{
		var aKeys = ["MSIE", "Firefox", "Safari", "Chrome", "Opera"],
        sUsrAg = navigator.userAgent, nIdx = aKeys.length - 1;
	    for (nIdx; nIdx > -1 && sUsrAg.indexOf(aKeys[nIdx]) === -1; nIdx--);
	    return aKeys[nIdx];
	}





	setCustomerFacingScreenContent(custScreenContent)
	{
		let minDelayForSlideShow = 9000;
		let store_format = 'KLM';
		this.storage.get('minDelayForSlideShow').then((data) => {
			minDelayForSlideShow = data;	
		});
		this.storage.get('store_format').then((data) => {
			store_format = data;
			return this.storage.get('isCfsMachine');
		}).then((data) => 
		{
			let json_capsule = JSON.stringify({
				'store_format' : store_format,
				'minDelayForSlideShow' : minDelayForSlideShow
			});

	    	this.hasCfsScreen = data;
			if( this.hasCfsScreen == 'unknown' || !this.hasCfsScreen ) {
				return true;	
			}
			
			let csobj = JSON.parse(custScreenContent);
			if( csobj.hasOwnProperty('action') && csobj['action'] == 'presalecheck') 
			{

				for (var i = 0; i <= csobj.td_barcodes_info.length-1; i++) {
					csobj.td_barcodes_info[i].gross =  this.formatIndianStyle.transform(csobj.td_barcodes_info[i].gross);
					csobj.td_barcodes_info[i].line_net_payable =  this.formatIndianStyle.transform(csobj.td_barcodes_info[i].line_net_payable);
					if( csobj.hasOwnProperty('line_discount') ) {
						csobj.td_barcodes_info[i].line_discount =  this.formatIndianStyle.transform(csobj.td_barcodes_info[i].line_discount);
					} else {
						var linedisc = Number(csobj.td_barcodes_info[i].promo_disc) + Number(csobj.td_barcodes_info[i].manual_discount);
						csobj.td_barcodes_info[i].line_discount =  this.formatIndianStyle.transform(linedisc.toString());
					}
				}
				csobj.store_format=store_format;
				csobj.minDelayForSlideShow=minDelayForSlideShow;
				var http = new XMLHttpRequest();
				var url = this.cfs_node_api_address + "/cfs_showcustomercontent";
				var params = JSON.stringify(csobj);
				http.open("POST", url, true);
				http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

				http.onreadystatechange = function() 
				{	
					if(http.readyState == 4 && http.status == 200) 
				    {
				        
				    }
				}
				http.send(params);
			} 
			else if( csobj.hasOwnProperty('action') && csobj['action'] == 'thankyou') 
			{
				var http = new XMLHttpRequest();
				var url = this.cfs_node_api_address + "/cfs_showthankyouimage";
				// var params = JSON.stringify(CustomerFacingContent);
				http.open("POST", url, true);
				http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

				http.onreadystatechange = function() 
				{	
					if(http.readyState == 4 && http.status == 200) {
				    }
				}
				http.send(json_capsule);
			} else {
				var http = new XMLHttpRequest();
				var url = this.cfs_node_api_address + "/cfs_showpromotionimages";
				http.open("POST", url, true);
				http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

				http.onreadystatechange = function() {
				    if(http.readyState == 4 && http.status == 200) {
				    }
				}
				http.send(json_capsule);
			}
		});
	}





	checkForCFS()
	{
		let minDelayForSlideShow = 9000;
		let store_format = 'MANDIR';
		this.storage.get('minDelayForSlideShow').then((data) => {
			minDelayForSlideShow = data;
		});

		this.storage.get('store_format').then((data) => 
		{
			store_format = data;
			let json_capsule = JSON.stringify({
				'store_format' : store_format,
				'minDelayForSlideShow' : minDelayForSlideShow
			});
			
			if(!window.location.hostname)
			{
				let headers = new Headers;
				headers.append('Content-type', 'application/json');
				headers.append('Access-Control-Allow-Origin', '*');
				let options = new RequestOptions({
					headers: headers
				});

				return this.http.post(this.cfs_node_api_address + "/cfs_checkdualmonitorexists", json_capsule , options )
				.map(response => response.json())
				.subscribe(data => {
					var response = JSON.parse(data);
					this.storage.set(`isCfsMachine`, response.hasCfs);
			    });
			}
			else
			{
				var http = new XMLHttpRequest();
				var url = this.cfs_node_api_address + "/cfs_checkdualmonitorexists";
				var params = json_capsule ;

				http.open("POST", url, true);
				http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
				http.onreadystatechange = (e) => {//Call a function when the state changes.
				    if(http.readyState == 4 && http.status == 200) 
				    {
						var response = JSON.parse(http.responseText);
						this.storage.set(`isCfsMachine`, response.hasCfs);
				    }
				};
				http.send(params);
		    }
		});

	}

	
}


// WEBPACK FOOTER //
// ./src/providers/constants/constants.ts